import { useEffect, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { responderUrl } from "./api";

const pickCamera = async (which) => {
  if (which === "front") return { facingMode: "user" };
  if (which === "usb") {
    const cams = await Html5Qrcode.getCameras().catch(() => []);
    const usb = cams.find((c) => !/front|back|rear|face|integrated|built/i.test(c.label)) || cams[cams.length - 1];
    if (usb) return usb.id;
  }
  return { facingMode: "environment" };
};

export function useCamera(active, onCode, source = "reader_qr", which = "back", elId = "qr-reader") {
  useEffect(() => {
    if (!active) return undefined;
    const qr = new Html5Qrcode(elId);
    let stopped = false;
    const started = pickCamera(which).then((cfg) => (stopped ? null : qr.start(cfg, { fps: 8, qrbox: 220 }, (text) => onCode(text, source)))).catch(() => null);
    return () => {
      stopped = true;
      started.then(() => (qr.isScanning ? qr.stop() : null)).then(() => qr.clear()).catch(() => {});
    };
  }, [active, onCode, source, which, elId]);
}

export function beep() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    o.frequency.value = 880;
    o.connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + 0.12);
  } catch { /* audio not available */ }
}

export const photoUrl = (token) => (token ? `${responderUrl(token).split("?")[0]}/photo` : null);

export const hhmm = (iso) => (iso ? new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "—");

export function downloadCsv(name, rows) {
  const cell = (c) => { const s = String(c ?? ""); return /^[=+\-@\t\r]/.test(s) ? `'${s}` : s; };
  const csv = rows.map((l) => l.map((c) => `"${cell(c).replace(/"/g, '""')}"`).join(",")).join("\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  a.download = name;
  a.click();
}

export function usePersisted(key, initial) {
  const [v, setV] = useState(() => { try { return JSON.parse(localStorage.getItem(key)) ?? initial; } catch { return initial; } });
  const set = (next) => { setV(next); localStorage.setItem(key, JSON.stringify(next)); };
  return [v, set];
}
